module.exports = __webpack_public_path__ + "static/media/hoveredDamagePin.c7a9ca9f.svg";